/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { useKYCUpdateStepperContext } from 'context/KYCUpdateStepper';
import { CountrySelect } from 'components/atoms';
import USCountry from './USCountry';
import OtherCountries from './OtherCountries';
import Base from '../_base';

const PersonalInformation: React.FC = () => {
  const { userCountry, setUserCountry } = useKYCUpdateStepperContext();

  const renderForm = () => {
    if (userCountry === 'US') {
      return <USCountry />;
    }
    if (userCountry) {
      return <OtherCountries />;
    }
    return <div>Please, select a country first.</div>;
  };

  return (
    <Base
      iconName="person"
      title="Personal Information"
      subtitle="Type your personal information in order to proceed with KYC process."
    >
      <CountrySelect
        selected={userCountry}
        onSelect={country => setUserCountry(country)}
      />
      {renderForm()}
    </Base>
  );
};

export default PersonalInformation;
